"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var get_1 = tslib_1.__importDefault(require("lodash/get"));
var snakeCase_1 = tslib_1.__importDefault(require("lodash/snakeCase"));
var staticData_1 = tslib_1.__importDefault(require("../staticData"));
var tokenStorage_1 = tslib_1.__importDefault(require("../lib/tokenStorage"));
var StaticData = /** @class */ (function () {
    function StaticData() {
        var _this = this;
        this.getEPLStatusesColors = function () {
            return {
                red: [
                    _this.CONST.EPL_STATUSES.NOT_AVAILABLE,
                    _this.CONST.EPL_STATUSES.NOT_APPROVED,
                    _this.CONST.EPL_STATUSES.REJECTED,
                ],
                orange: [_this.CONST.EPL_STATUSES.RECRUITMENT],
                green: [
                    _this.CONST.EPL_STATUSES.FOR_MANAGER_APPROVAL,
                    _this.CONST.EPL_STATUSES.SUBMITTED,
                    _this.CONST.EPL_STATUSES.REQUESTED,
                    _this.CONST.EPL_STATUSES.SCHEDULED,
                    _this.CONST.EPL_STATUSES.NOT_INTERVIEWED,
                    _this.CONST.EPL_STATUSES.INTERVIEWED,
                ],
            };
        };
        /**
         * Returns a color based on the EPL status
         *
         * @param {Number} eplStatusId EPL status
         * @returns {string} 'red', 'orange' or 'green'
         */
        this.getStatusColor = function (eplStatusId) {
            var statusColorMap = _this.getEPLStatusesColors();
            var colors = Object.keys(statusColorMap);
            var color = colors.find(function (color) { return statusColorMap[color].includes(eplStatusId); });
            return color;
        };
        this.decorateWithConstAndNames = function (data) {
            var resources = [
                'accountTypes',
                'conditions',
                'contractCategories',
                'contractConditions',
                'contractCoverages',
                'contractStatuses',
                'contractPriorities',
                'contractTypes',
                'contractTypeDetails',
                'countries',
                'currencies',
                'employeePositions',
                'eplStatuses',
                'industries',
                'feeInvoiceDelayReasons',
                'invoiceDelayReasons',
                'invoicingCoverages',
                'invoiceStatuses',
                'languageProficiencies',
                'languages',
                'permissions',
                'phoneTypes',
                'projectCategories',
                'projectStatuses',
                'projectTypes',
                'projectRequiredResources',
                'subIndustries',
                'timezones',
                'eplOutputTypes',
                'expertFocusRegions',
                'expertStatuses',
                'eplPreliminaryTags',
                'eplReplyStatusComments',
                'deliverableTypes',
                'feeTypes',
                'paymentServiceTypes',
                'paymentTransferMethods',
                'costTypes',
                'paymentStatuses',
                'expertPaymentDetailStatuses',
                'eplStatusComments',
                'vatClasses',
                'pricings',
                'replyStatuses',
                'invoiceTypes',
                'taxTypes',
                'invoicePaymentStatuses',
                'userTypes',
                'complianceTypes',
            ];
            var CONST = {};
            data.names = {};
            resources.forEach(function (resource) {
                // Add safety check: skip if resource doesn't exist in the response
                if (!data[resource] || !Array.isArray(data[resource])) {
                    return;
                }
                data.names[resource] = {};
                var constCat = (0, snakeCase_1.default)(resource).toUpperCase();
                CONST[constCat] = {};
                data[resource].forEach(function (item) {
                    if (item.name) {
                        data.names[resource][item.id] = item.name;
                        CONST[constCat][(0, snakeCase_1.default)(item.name).toUpperCase()] = item.id;
                    }
                });
            });
            data.CONST = CONST;
            return data;
        };
        (0, mobx_1.extendObservable)(this, {
            staticData: null,
            EPLStatusesColors: (0, mobx_1.computed)(this.getEPLStatusesColors),
            loading: false,
            error: null,
        });
        this.loadData();
    }
    StaticData.prototype.loadData = function () {
        var _this = this;
        this.loading = true;
        // Use authenticated endpoint if token exists, otherwise use public endpoint
        var hasToken = !!tokenStorage_1.default.get();
        var apiMethod = hasToken ? staticData_1.default.getStaticData : staticData_1.default.getStaticDataPublic;
        apiMethod()
            .then(function (staticData) {
            staticData = _this.decorateWithConstAndNames(staticData);
            Object.assign(_this, staticData);
            _this.staticData = staticData;
            _this.loading = false;
        })
            .catch(function (err) {
            _this.error = err;
            _this.loading = false;
        });
    };
    /*
          This works when there's array with fields:
          - id, name
          in staticData
      */
    StaticData.prototype.getDataFromArray = function (id, arr) {
        if (!id || !arr || !this[arr])
            return null;
        return this[arr].find(function (item) { return item.id === id; }).name;
    };
    StaticData.prototype.getFullDataFromArray = function (id, arr) {
        if (!id || !arr || !this[arr])
            return null;
        return this[arr].find(function (item) { return item.id === id; });
    };
    StaticData.prototype.renderCountry = function (countryId) {
        var countryNames = (0, get_1.default)(this.staticData, 'names.countries', {});
        return countryNames[countryId];
    };
    StaticData.prototype.renderTimezone = function (timezoneId) {
        var timezoneNames = (0, get_1.default)(this.staticData, 'names.timezones', {});
        return timezoneNames[timezoneId];
    };
    StaticData.prototype.renderPhoneType = function (phoneTypeId) {
        var phoneTypeNames = (0, get_1.default)(this.staticData, 'names.phoneTypes', {});
        return phoneTypeNames[phoneTypeId];
    };
    StaticData.prototype.getHonorariumCurrencyOptions = function (enabledJPY) {
        if (enabledJPY === void 0) { enabledJPY = false; }
        var _a = this.staticData.CONST.CURRENCIES, EUR = _a.EUR, USD = _a.USD, CNY = _a.CNY, GBP = _a.GBP, KRW = _a.KRW, JPY = _a.JPY;
        var currencies = enabledJPY ? [EUR, USD, CNY, GBP, KRW, JPY] : [EUR, USD, CNY, GBP, KRW];
        var honorariumCurrencies = this.staticData.currencies.filter(function (c) { return currencies.includes(c.id); });
        return honorariumCurrencies;
    };
    StaticData.prototype.getClientProjectFeedbackQuestions = function (projectType) {
        var _a = this.staticData.CONST.PROJECT_TYPES, EXPERT_BACKED_RESEARCH = _a.EXPERT_BACKED_RESEARCH, EXPERT_SURVEY_RESEARCH = _a.EXPERT_SURVEY_RESEARCH;
        var ebresrQuestions = [
            {
                questionName: 'Project scope',
                question: 'Were your project needs well understood and met to your expectations throughout the duration of the project? (10 being highly understood, 1 not understood at all)',
            },
            {
                questionName: 'Delivery speed',
                question: 'How satisfied were you with the speed of Atheneum expert sourcing? (10 being Extremely satisfied, 1 Extremely dissatisfied)',
            },
            {
                questionName: 'Output quality',
                question: 'Were you satisfied with the final product delivered by Atheneum (10 being Extremely satisfied, 1 Extremely dissatisfied)',
            },
            {
                questionName: 'Overall experience',
                question: 'How likely are you to recommend Atheneum to your colleagues or friends? (10 being Extremely likely, 1 Not at all likely)',
            },
        ];
        var esepQuestions = [
            {
                questionName: 'Expert quality',
                question: 'How satisfied were you with the quality of Atheneum experts / market intelligence delivered to you? (10 being Extremely satisfied, 1 Extremely dissatisfied)',
            },
            {
                questionName: 'Delivery speed',
                question: 'How satisfied were you with the speed of Atheneum expert sourcing? (10 being Extremely satisfied, 1 Extremely dissatisfied)',
            },
            {
                questionName: 'Project handling',
                question: 'How satisfied were you with the handling of the project by Atheneum professionals in ensuring a smooth and timely delivery (10 being Extremely satisfied, 1 Extremely dissatisfied)',
            },
            {
                questionName: 'Overall experience',
                question: 'How likely are you to recommend Atheneum to your colleagues or friends? (10 being Extremely likely, 1 Not at all likely)',
            },
        ];
        return [EXPERT_BACKED_RESEARCH, EXPERT_SURVEY_RESEARCH].includes(projectType) ? ebresrQuestions : esepQuestions;
    };
    return StaticData;
}());
exports.default = new StaticData();
